import { render, staticRenderFns } from "./HealthRequest.vue?vue&type=template&id=30c5cd0a&scoped=true"
import script from "./HealthRequest.vue?vue&type=script&lang=js"
export * from "./HealthRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c5cd0a",
  null
  
)

export default component.exports